module.exports = __webpack_public_path__ + "static/media/LEFT.c777eebf.svg";